import * as ActionTypes from './ActionTypes'

export function setOrderNumberMin(orderNumberMin) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNINVOICE_MANAGER_SET_ORDER_NUMBER_MIN,
      orderNumberMin,
    })
  }
}

export function setOrderNumberMax(orderNumberMax) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNINVOICE_MANAGER_SET_ORDER_NUMBER_MAX,
      orderNumberMax,
    })
  }
}
